import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailPasswordCredentials } from '../../core/models/email-password-credentials';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/services/auth.service';
import { Constants } from '../../core/config/Constants';
import { Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility.service';
import { ExtraService } from '../../core/services/extra.service';
import { ProfileService } from '../../core/services/profile.service';
import { ProfileInfo } from '../../core/models/profile-info';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers:[AuthService,FormBuilder,ProfileService]
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  user = new EmailPasswordCredentials();
  errorMessage:string;
  isError :boolean = false;
  
    
  constructor(private profileService :ProfileService,private fb: FormBuilder,private extraService :ExtraService,private authService: AuthService,private router: Router,private utilityService:UtilityService) { 
   
    this.loginForm = fb.group({
        'email' : ['', Validators.compose([Validators.required, Validators.email])],
        'password' : ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      });
    }
  
    ngOnInit() {
      if (this.utilityService.isLogged()) {
        this.router.navigate([Constants.WELCOME_URL]);
      }else{
        this.extraService.changeStateLogin();
      } 
    }

    submitLogin(credentials){
      this.isError = false;
      if(this.loginForm.valid){
        this.user = credentials;
        this.isError = false;
        this.authService.loginUser(this.user).then((user) => {
          console.log({user})
          this.utilityService.isLogged();
          this.utilityService.setUser(user);
          this.extraService.changeStateLogin();
          this.router.navigate([Constants.WELCOME_URL]);
        }).catch(error => {
          this.errorMessage = error.message;
          this.isError = true;
        });
      }else{
        this.errorMessage = 'Please fill valid data';
        this.isError = true;
      }
    }

    googleLogin(){
      this.authService.loginWithGoogle().then(response=>{
        console.log(response);
        this.profileService.isUserProfile(response.user.email).then((snapshot)=>{
          if(!snapshot.val()) {
              let profile = new ProfileInfo();
              profile.name = response.user.displayName;
              profile.email = response.user.email;
              profile.isPhoneNumberVisible = true;
              profile.isProfileImageVisible = false;
              profile.phoneNo = response.user.phoneNumber;
              profile.profileImageUri = response.user.photoURL;
              this.profileService.setUserProfile(profile);
            }
            this.utilityService.setUser(response.user);
            this.extraService.changeStateLogin();
            this.router.navigate([Constants.WELCOME_URL]);
        }).catch(error=>{
          this.errorMessage = error.message;
          this.isError = true;
        });
       }).catch(error=>{
        this.errorMessage = error.message;
        this.isError = true;
       });
    }
    forgotPassword(credentials){
      this.router.navigate([Constants.FORGOT_PASS_URL]);
    }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/user/login/login.component.ts